export default {"src":"/_next/static/media/img-payment-pending.86f77be7.svg","height":143,"width":143,"blurWidth":0,"blurHeight":0};